import { $enum } from 'ts-enum-util'
import * as yup from 'yup'
import { LOAD_STATE } from 'apps/fleet-planner/constants/loads'

export const ShipmentStatusSchema = yup
  .mixed<LOAD_STATE>()
  .oneOf([...$enum(LOAD_STATE).getValues()])
  .default(LOAD_STATE.Pending)
